<!-- ASIGNAMOS UN ID ÚNICO Y ESTRUCTURA SCHEMA.ORG ITEMLIST / RECIPE -->
<section id="cocteleria-section" class="container mixology-section" itemscope itemtype="https://schema.org/ItemList">
  <meta itemprop="name" content="Recetario de Coctelería de Autor Estancos Distilling Co." />
  <meta itemprop="description"
    content="Recetas exclusivas de coctelería artesanal preparadas con Ron Legarda y Whisky Real Audiencia a 2500 msnm." />

  @if (isLoading()) {
  <!-- LOADER ACCESIBLE -->
  <div class="loader-container" role="status" aria-live="polite">
    <div class="spinner" aria-hidden="true"></div>
    <div class="loader-text">Preparando Recetas de Coctelería...</div>
  </div>
  } @else {

  <!-- SI NO HAY RECETA SELECCIONADA: MOSTRAMOS LA CUADRÍCULA DE CÓCTELES -->
  @if (!selectedCocktail()) {

  <header class="section-header">
    <span class="section-subtitle">Mixología de Autor & Maridaje</span>
    <h2>Coctelería de Autor</h2>
    <p class="section-lead-text">
      Descubre creaciones exclusivas de nuestros mixólogos. Recetas diseñadas para potenciar los matices aromáticos de
      nuestros destilados andinos.
    </p>
  </header>

  <!-- FILTROS DINÁMICOS POR LICOR BASE -->
  <div class="filters-container" role="group" aria-label="Filtros por licor base">
    @for (category of categories(); track category) {
    <button class="filter-btn" [class.active]="activeFilter() === category" (click)="setFilter(category)"
      [attr.aria-pressed]="activeFilter() === category">
      {{ category === 'todos' ? 'Todos los licores' : category }}
    </button>
    }
  </div>

  <div class="blog-grid" role="list">
    @if (filteredCocktails().length === 0) {
    <div class="no-results">
      No hay recetas disponibles para este licor base en este momento.
    </div>
    } @else {
    @for (post of filteredCocktails(); track post.id; let i = $index) {

    <!-- TARJETA DE CÓCTEL (SCHEMA.ORG RECIPE / ITEMLISTELEMENT) -->
    <article class="blog-card" (click)="openRecipe(post)" role="listitem" itemprop="itemListElement" itemscope
      itemtype="https://schema.org/Recipe">
      <meta itemprop="position" [content]="i + 1" />
      <meta itemprop="name" [content]="post.title" />
      <meta itemprop="recipeCategory" [content]="post.base_spirit" />
      <meta itemprop="prepTime" [content]="post.read_time" />
      <meta itemprop="description" [content]="getFormattedSemanticDescription(post)" />

      <div class="card-image-wrapper">
        <span class="card-tag">{{ post.base_spirit }}</span>
        <img [src]="post.image_url" [alt]="'Cóctel ' + post.title + ' - Receta con ' + post.base_spirit"
          class="card-image" loading="lazy" decoding="async" itemprop="image" (error)="onImageError($event)">
      </div>

      <div class="card-content">
        <div class="card-meta">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
            aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{{ post.read_time }} de preparación</span>
        </div>

        <h3 class="card-title" itemprop="name">{{ post.title }}</h3>
        <p class="card-excerpt">{{ post.excerpt }}</p>

        <div class="read-more">
          <span>Ver Receta Completa</span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
            aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </div>
      </div>

    </article>
    }
    }
  </div>
  }

  <!-- SI HAY RECETA SELECCIONADA: MOSTRAMOS EL ARTÍCULO Y RECETA COMPLETA -->
  @else {

  <!-- BOTÓN VOLVER SUPERIOR -->
  <div class="recipe-navigation-top">
    <button type="button" class="btn-back" (click)="closeRecipe()"
      aria-label="Volver al catálogo de recetario de coctelería de autor">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" stroke-width="2.5" aria-hidden="true" class="back-icon">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
      </svg>
      <span>Volver al Catálogo de Coctelería</span>
    </button>
  </div>

  <!-- ARTÍCULO PRINCIPAL DE LA RECETA (SCHEMA.ORG RECIPE) -->
  @if (selectedCocktail(); as cocktail) {
  <article class="recipe-article" itemscope itemtype="https://schema.org/Recipe">
    <meta itemprop="name" [content]="cocktail.title" />
    <meta itemprop="recipeCategory" [content]="cocktail.base_spirit" />
    <meta itemprop="prepTime" [content]="cocktail.read_time" />
    <meta itemprop="description" [content]="getFormattedSemanticDescription(cocktail)" />

    <!-- HERO DE LA RECETA CON SUPERPOSICIÓN DE TEXTO Y VALORES -->
    <header class="article-hero">
      <img [src]="cocktail.image_url" [alt]="'Receta y presentación final del cóctel ' + cocktail.title"
        itemprop="image" (error)="onImageError($event)">
      <div class="article-hero-overlay">
        <span class="card-tag">{{ cocktail.base_spirit }}</span>
        <h1 class="article-title" itemprop="name">{{ cocktail.title }}</h1>

        <div class="article-meta">
          <div class="meta-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Tiempo: {{ cocktail.read_time }}</span>
          </div>
          <div class="meta-item level-item">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 24 24"
              stroke="currentColor" stroke-width="2" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
            </svg>
            <span>Nivel: Mixología Artesanal</span>
          </div>
        </div>
      </div>
    </header>

    <!-- CUERPO DE LA RECETA (INGREDIENTES Y PASO A PASO) -->
    <div class="article-body">

      <!-- COLUMNA IZQUIERDA: INGREDIENTES -->
      <div class="article-ingredients">
        <h3>Ingredientes</h3>
        <ul class="ingredients-list" role="list">
          @for (ingredient of cocktail.ingredients; track $index) {
          <li role="listitem" itemprop="recipeIngredient">{{ ingredient }}</li>
          }
        </ul>

        <!-- BLOQUE DE TRIPLETAS SEMÁNTICAS (OPTIMIZADO PARA AEO) -->
        <div class="semantic-triplets-box" aria-label="Atributos de mixología y maridaje">
          <span class="triplets-header-title">Perfil de Mixología</span>
          <ul class="triplets-list">
            @for (triplet of getSemanticTriplets(cocktail); track $index) {
            <li class="triplet-item" itemscope itemtype="https://schema.org/PropertyValue">
              <span class="triplet-subject" itemprop="name">{{ triplet.subject }}</span>
              <span class="triplet-predicate">{{ triplet.predicate }}</span>
              <span class="triplet-object" itemprop="value">{{ triplet.object }}</span>
            </li>
            }
          </ul>
        </div>
      </div>

      <!-- COLUMNA DERECHA: PASO A PASO (INSTRUCCIONES) -->
      <div class="article-instructions">
        <h3>Preparación Paso a Paso</h3>
        <ol class="instructions-list" role="list" itemprop="recipeInstructions">
          @for (step of cocktail.instructions; track $index) {
          <li role="listitem" itemprop="step">{{ step }}</li>
          }
        </ol>
      </div>

    </div>

  </article>

  <!-- BOTÓN VOLVER INFERIOR (MÁXIMA ACCESIBILIDAD AL FINALIZAR LA LECTURA) -->
  <div class="recipe-navigation-bottom">
    <button type="button" class="btn-back" (click)="closeRecipe()"
      aria-label="Volver al catálogo de recetario de coctelería de autor">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24"
        stroke="currentColor" stroke-width="2.5" aria-hidden="true" class="back-icon">
        <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
      </svg>
      <span>Volver al Catálogo de Coctelería</span>
    </button>
  </div>
  }
  }
  }

</section>